import { isEqual, omitBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetWarehousesByAdminQuery } from 'src/_api/warehouseApi';
import { ServerAutoCompleteSearch } from 'src/_modules/common';

export default function AdminWarehousesAutocomplete({ name, value, onChange, label, role, merchant = null, ...props }) {
    const { t } = useTranslation();

    const [params, setParams] = useState({
        page: 1,
        limit: 20,
        searchKey: '',
        role: role,
        merchant,
    });

    const [hasNextPage, setHasNextPage] = useState(true);

    const { data, isLoading, isFetching } = useGetWarehousesByAdminQuery(omitBy(params, v => !v));
          console.log( "isFetching" , isFetching);
          
    const [warehouses, setWarehouses] = useState([]);

    useEffect(() => {
        if (data) {
            setWarehouses((prev) => {
                if (data?.page === 1) {
                    return data?.docs ?? []
                }

                const previous = prev ?? []
                const incoming = data?.docs ?? []
                const prevIds = new Set(previous.map((warehouse) => warehouse?.id))
                const dedupedIncoming = incoming.filter((warehouse) => !prevIds.has(warehouse?.id))
                return [...previous, ...dedupedIncoming]
            });
            setHasNextPage(data?.hasNextPage);
        }
    }, [data]);

    useEffect(() => {
        setParams((prev) => {
            if (isEqual(prev?.merchant, merchant)) {
                return prev
            }

            setWarehouses([])
            return {
                ...prev,
                page: 1,
                searchKey: '',
                merchant,
            }
        });
    }, [merchant]);

    return (
        <ServerAutoCompleteSearch
            hasNextPage={hasNextPage}
            onLoadMore={() => setParams((prev) => ({ ...prev, page: prev.page + 1 }))}
            onOpen={() => {
                // Restore the full list when reopening after a search filtered it
                if (params.searchKey) {
                    setWarehouses([])
                    setParams((prev) => ({ ...prev, page: 1, searchKey: '' }))
                }
            }}
            label={label ?? t('Warehouse')}
            fullWidth
            getOptionLabel={(option) => `${option?.name} - ${option?.merchant?.companyName}` ?? ''}
            onInputChange={(value) => {
                setParams((prev) => ({ ...prev, searchKey: value, page: 1 }));
                setWarehouses([]);
            }}
            onChange={(newValue) => onChange({ target: { name, value: newValue } })}
            value={value}
            size="small"
            loading={isLoading || isFetching}
            options={warehouses ?? []}
            error={undefined}
            {...props}
        />
    );
}
